<template>
<!--  <div class="home" style="background: linear-gradient(180deg,#ffffff,#ffffff,#f4f4f4)">-->
<!--  <v-main style="background: linear-gradient(180deg, rgb(5,71,160) 0, rgba(5,71,160,0.5) 10%, rgba(255,255,255,0.5) 90%, rgba(255,255,255,0.5) 100%);">-->
  <v-container>
<!--    <div style="height: 1000px; width: 1000px; position: absolute; top: 0; left: 0%; background: radial-gradient(circle at top left, rgba(5,71,160,0.2) 0, rgba(0,0,0,0) 50%)"></div>-->
<!--    <div style="height: 2000px; width: 2000px; position: absolute; top: 75vh; left: 1%; background: radial-gradient(circle at center, rgba(5,71,160,0.2) 0, rgba(0,0,0,0) 50%)"></div>-->
<!--    <div style="height: 1000px; width: 1000px; position: absolute; top: -1; left: -1px; background: radial-gradient(circle at top left, rgba(5,71,160,0.1) 0, rgba(0,0,0,0) 50%)"></div>-->

    <v-img max-height="400px" contain src="../assets/smrt-bygg-fg.png"></v-img>

<!--    <v-container>-->
        <v-row justify="center" class="align-center">

<!--          DESKTOP-->
          <v-col cols="12" md="6">
<!--                  <v-card class="rounded" style="background-color: rgba(255,255,255,0.2); aspect-ratio: 16/9">-->
<!--                    <v-card-title style="padding: 5px">-->
<!--                      <span style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 35%; height: 16px" disabled></span>-->
<!--                      <v-spacer></v-spacer>-->
<!--                      <span class="mx-1" style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 14px; height: 14px"></span>-->
<!--                      <span class="mx-1" style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 14px; height: 14px"></span>-->
<!--                      <span class="mx-1" style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 14px; height: 14px"></span>-->
<!--                    </v-card-title>-->
<!--                    <v-card-text style="padding: 0 1em 1em 1em">-->
                      <v-img class="rounded" contain src="../assets/smrt-bygg-mock.png"></v-img>
<!--                    </v-card-text>-->
<!--                  </v-card>-->
          </v-col>

<!--          APP-->
<!--          <v-col cols="12" md="4">-->
<!--            <v-card flat class="rounded" style="background: linear-gradient(135deg, rgba(5,71,160,0.4) 0, rgba(255,255,255,0) 25%, rgba(255,255,255,0) 75%, rgba(5,71,160,0.4) 100%); padding: 1em 0 0 1em">-->

<!--              <div>-->
<!--                <v-card class="rounded" style="background-color: rgba(255,255,255,0.2); aspect-ratio: 9/16">-->
<!--                  <v-card-title>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-btn width="35%" depressed dark x-small style="background-color: rgba(5,71,160,1)">Smart bygg</v-btn>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    &lt;!&ndash;                        <v-icon disabled>mdi-circle</v-icon>&ndash;&gt;-->
<!--                    &lt;!&ndash;                        <v-icon disabled>mdi-circle</v-icon>&ndash;&gt;-->
<!--                    &lt;!&ndash;                        <v-icon disabled>mdi-circle</v-icon>&ndash;&gt;-->
<!--                  </v-card-title>-->
<!--                  <v-card-text style="padding: 0 1em 1em 1em">-->
<!--                    <v-img class="rounded" src="../assets/EMS-1200x629.png"></v-img>-->
<!--                  </v-card-text>-->
<!--                </v-card>-->
<!--              </div>-->
<!--            </v-card>-->
<!--          </v-col>-->

          <v-col cols="12" md="6">
            <v-card flat style="border-radius: 25px; background-color: rgba(0,0,0,0)" class="text-center align-center justify-center">
<!--            <v-card style="border-radius: 25px;" class="text-center align-center justify-center">-->
<!--            <v-card-title>-->
            <div style="margin: 5em">
              <h2 style="margin: 1em">
                Intelligente bygg
              </h2>
<!--            </v-card-title>-->
              <ul>
                <li>Senk energi og driftskostnader</li>
<!--                <li>Integrer med eksisterende utstyr og SD-anlegg</li>-->
                <li>Integrer med eksisterende anlegg</li>
                <li>Automatiser etter behov</li>
              </ul>
              <v-card-actions class="text-center align-center justify-center">
                <v-btn class="primary" style="margin-top: 1em; padding: 0 3em 0 3em"
                       rounded depressed to="/bms">
                  Les mer
<!--                  <v-icon class="mdi-spin">mdi-brain</v-icon>-->
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
          </v-col>

          <v-col class="align-center text-center" cols="12">

<!--            <v-row justify="space-around">-->
<!--              <v-col>-->
<!--                <v-avatar class="primary" size="128">-->
<!--&lt;!&ndash;                  <v-img src="../assets/campaign-creators-pypeCEaJeZY-unsplash.jpg"></v-img>&ndash;&gt;-->
<!--                  <v-icon size="128">mdi-account-hard-hat</v-icon>-->
<!--                </v-avatar>-->
<!--                <p>For installatører</p>-->
<!--              </v-col>-->

<!--              <v-col>-->
<!--                <v-avatar size="128">-->
<!--&lt;!&ndash;                  <v-img src="../assets/photo-1533390178274-fe0b47d5e557.png"></v-img>&ndash;&gt;-->
<!--                  <v-icon color="primary" size="128">mdi-office-building</v-icon>-->
<!--                </v-avatar>-->
<!--                <p>For bedrifter</p>-->
<!--              </v-col>-->

<!--              <v-col>-->
<!--                <v-avatar size="128">-->
<!--&lt;!&ndash;                  <v-img src="../assets/towfiqu-barbhuiya-Ifwa_eU0PPM-unsplash.jpg"></v-img>&ndash;&gt;-->
<!--                  <v-icon size="128">mdi-account</v-icon>-->
<!--                </v-avatar>-->
<!--                <p>For private personer</p>-->
<!--              </v-col>-->

<!--            </v-row>-->

            <v-row justify="space-around">
              <v-col>
                <v-avatar size="256">
                  <v-img src="../assets/landscape-ipad-mini-mockup-of-a-female-architect-at-work-a12568.png"></v-img>
                </v-avatar>
                <p>For installatører</p>
              </v-col>

              <v-col>
                <v-avatar size="256">
                  <v-img src="../assets/ipad-mockup-in-landscape-position-featuring-a-smiling-woman-in-a-bus-12957s.png"></v-img>
                </v-avatar>
                <p>For byggeiere</p>
              </v-col>

              <v-col>
                <v-avatar size="256">
                  <v-img src="../assets/t-shirt-mockup-featuring-a-young-student-taking-notes-in-a-classroom-m12980-r-el2.png"></v-img>
                </v-avatar>
                <p>For fremtiden</p>
              </v-col>

            </v-row>
          </v-col>

<!--          <v-col>-->

<!--            <v-img :src="require('../assets/energibrnn-screenshot.png')"></v-img>-->

<!--          </v-col>-->


<!--          <v-col cols="12" md="6">-->
<!--            <v-card flat style="border-radius: 25px; background-color: rgba(0,0,0,0)" class="text-center align-center justify-center">-->
<!--              <div style="margin: 5em">-->
<!--                <h2 style="margin: 1em">-->
<!--                  Digital kjørebok-->
<!--                </h2>-->
<!--                <ul>-->
<!--                  <li>Hold oversikten</li>-->
<!--                  <li>Vit hvor verktøyet ligger</li>-->
<!--                  <li>Osv</li>-->
<!--                </ul>-->
<!--                <v-card-actions class="text-center align-center justify-center">-->
<!--                  <v-btn class="primary" style="margin-top: 1em; padding: 0 3em 0 3em"-->
<!--                         rounded depressed to="/systems">-->
<!--                    Les mer-->
<!--                  </v-btn>-->
<!--                </v-card-actions>-->
<!--              </div>-->
<!--            </v-card>-->
<!--          </v-col>-->

<!--          <v-col cols="12">-->
<!--            <v-card class="rounded" style="background-color: rgba(255,255,255,0.2); aspect-ratio: 16/9">-->
<!--              <v-card-title style="padding: 5px">-->
<!--                <span style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 35%; height: 16px" disabled></span>-->
<!--                <v-spacer></v-spacer>-->
<!--                <span class="mx-1" style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 14px; height: 14px"></span>-->
<!--                <span class="mx-1" style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 14px; height: 14px"></span>-->
<!--                <span class="mx-1" style="background-color: rgba(0, 0, 0, 0.2); border-radius: 25px; width: 14px; height: 14px"></span>-->
<!--              </v-card-title>-->
<!--              <v-card-text style="padding: 0 1em 1em 1em">-->
<!--&lt;!&ndash;                <v-img class="rounded" contain src="../assets/EMS-1200x629.png"></v-img>&ndash;&gt;-->
<!--                <v-img class="rounded" :src="require('../assets/energibrnn-screenshot.png')"></v-img>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-col>-->
        </v-row>



<!--        <v-row>-->
<!--          <v-col>-->
<!--            Det er valgfritt i hvor stor grad man ønsker å automatisere byggene. Teknologien er skalerbar og byggene kan oppgraderes stegvis. Nedenfor er eksempler på løsninger som kan innføres.-->
<!--          </v-col>-->
<!--        </v-row>-->



<!--        <v-row>-->
<!--          <v-col cols="12" sm="6" md="4" v-for="(card, index) in cards" v-bind:key="'infcard' + index">-->
<!--  &lt;!&ndash;          <v-card style="width: 100%">&ndash;&gt;-->
<!--            <v-row class="ma-0 pa-0">-->
<!--  &lt;!&ndash;            <v-col class="ma-0 pa-0">&ndash;&gt;-->

<!--                <v-card class="d-flex align-center justify-center" height="50px" width="50px"-->
<!--                        style="background: linear-gradient(135deg, #1ed6b2 0%, #1ed6b2 50%, #1bbc9c 50%, #1bbc9c 100%)">-->
<!--                  <v-icon style="font-size: 32px; color: white">-->
<!--                    {{card.icon}}-->
<!--                  </v-icon>-->
<!--                </v-card>-->

<!--  &lt;!&ndash;            </v-col>&ndash;&gt;-->
<!--  &lt;!&ndash;            <v-col class="ma-0 pa-0">&ndash;&gt;-->
<!--                <v-subheader style="word-break: break-word">-->
<!--                  {{card.title}}-->
<!--                </v-subheader>-->
<!--  &lt;!&ndash;            </v-col>&ndash;&gt;-->
<!--            </v-row>-->

<!--            <v-row class="ma-0">-->
<!--              <v-col class="pa-0" cols="12">-->
<!--                <v-card-text>-->
<!--                  {{card.text}}-->
<!--                </v-card-text>-->
<!--              </v-col>-->
<!--            </v-row>-->

<!--          </v-col>-->
<!--        </v-row>-->
<!--    </v-container>-->

<!--    <v-footer padless ref="footer">-->
<!--      <v-card flat tile>-->

<!--        <v-row>-->
<!--          <v-col cols="12">-->
<!--            <header>Would you like to know more?</header>-->
<!--            <v-divider></v-divider>-->
<!--            <v-subheader>contact info</v-subheader>-->
<!--            <label>Send us your email for </label>-->
<!--            <v-text-field label="Email"></v-text-field>-->
<!--          </v-col>-->
<!--&lt;!&ndash;        </v-row>&ndash;&gt;-->

<!--&lt;!&ndash;        <v-row>&ndash;&gt;-->
<!--          <v-col cols="6">-->
<!--            SS logo-->
<!--          </v-col>-->
<!--          <v-col cols="6">-->
<!--            PS logo-->
<!--          </v-col>-->
<!--        </v-row>-->

<!--      </v-card>-->
<!--    </v-footer>-->

<!--      <v-toolbar class="primary interest-bar" dark flat>-->
<!--        <v-toolbar-title ref="bms">-->
<!--          Intelligente bygg-->
<!--        </v-toolbar-title>-->
<!--      </v-toolbar>-->

<!--      <BMSView>-->
<!--      </BMSView>-->


<!--      <v-toolbar class="primary interest-bar" dark flat>-->
<!--        <v-toolbar-title ref="systems">-->
<!--          Systems (kjørebok ++)-->
<!--        </v-toolbar-title>-->
<!--      </v-toolbar>-->


<!--      <SystemsView>-->
<!--      </SystemsView>-->
<!--    </v-container>-->
  </v-container>
</template>

<script>
  // import SlideShow from "@/components/Slideshow";
  // import BMSView from "@/views/BMS";
  // import SystemsView from "@/views/Systems";
  export default {
    name: 'Home-view',

    components: {
      // SlideShow
      // BMSView,
      // SystemsView,
    },
    data: () => ({
      fab: false,
      cards: [
          {
            icon: 'mdi-lightbulb',
            title: 'SMART LYSSTYRING',
            text: 'Intelligent styring av lys ved bruk av blant annet bevegelses- og lyssensorer, samt smarte tidsplaner, gir lavere energiforbruk og bedre innemiljø. Varslinger når lyspærer og rør må byttes sparer driftere av bygg enormt med tid.',
          },
          {
            icon: 'mdi-air-filter',
            title: 'SMART VENTILASJON',
            text: 'Intelligent styring og monitorering av HVAC basert på flere sensorer sørger for optimalt inneklima og energiforbruk, i tillegg varslinger ved feil.',
          },
          {
            // icon: 'mdi-thermostat',
            icon: 'mdi-thermometer',
            title: 'SMART VARME',
            text: 'Intelligent styring av varme ved bruk av sensorer og smart programmering gir bedre innemiljø og lavere energiforbruk.',
          },
          {
            icon: 'mdi-leaf',
            title: 'INNEKLIMA MÅLINGER',
            text: 'Kontinuerlig inneklima målinger, blant annet temperatur, fukt, CO2 og luftkvalitet gir godt grunnlag for dokumentasjon og driftere av bygg sparer tid på å slippe manuelle kontroller.',
          },
          {
            icon: 'mdi-account-group',
            title: 'STØV OG TILSTEDEVÆRELSE',
            text: 'Monitorering av støv og hvor mye lokaler har vært i bruk, bidrar til besparelser ved å minske unødvendig vasking.',
          },
          {
            icon: 'mdi-cellphone',
            title: 'FJERNSTYRING',
            text: 'Elementer i byggene kan enkelt fjernstyres via mobil app eller dashboard.',
          },
          {
            icon: 'mdi-alert',
            title: 'SIKKERHET OG VARSLING',
            text: 'Kontinuerlig oversikt over status på komponenter i byggene og tidlige varslinger ved avvik bidrar til enklere og billigere drift.',
          },
          {
            icon: 'mdi-content-copy',
            title: 'RAPPORTERING',
            text: 'Innsamling av sensordata i skyen gir enkel oversikt og dokumentasjon, og grunnlag for ytterligere besparelser og effektivisering.',
          },
          {
            icon: 'mdi-server',
            title: 'PLATTFORM',
            text: 'En felles åpen plattform og tjenester i skyen sørger for datainnsamling og samhandling med andre systemer.',
          },
      ]
    }),
    mounted () {
      window.scrollTo(0, 0)
    },
    methods: {
      onClick() {
        console.log('clicked.')
      }
    }
  }
</script>
<style>

main {
  background: linear-gradient(135deg, rgba(5,71,160,0.8) 0%, rgba(5,71,160,0) 65%, rgba(5,71,160,0.2) 100%);
}

.v-btn {
  text-transform:none !important;
}
.interest-bar {
  margin-top: 5em;
}
.interest-grid {
  display: grid;
  gap: 1em;
  grid-template-columns: 1fr 1fr 1fr;
}
.interest-cards {
  cursor: pointer;
  height: 200px;
  overflow: hidden;
}


/*main {*/
/*!*  background: linear-gradient(-45deg, rgba(100,100,255,0.8), rgba(255,255,255,0.2), rgba(35,166,213,0.6), rgba(35,213,171,0.3));*!*/
/*!*  !*background: linear-gradient(-45deg,rgba(100,100,255,0.6),rgba(35,166,213,0.6), rgba(35,213,171,0.3));*!*!*/
/*!*  !*background: linear-gradient(135deg, rgba(5,71,160,1) 0%, rgba(5,71,160,0) 100%);*!*!*/
/*background: linear-gradient(135deg, rgba(5,71,160,1), rgba(5,71,160,0.1));*/
/*  background-size: 400% 400%;*/
/*  animation: gradient 20s ease-in-out infinite;*/
/*}*/

/*@keyframes gradient {*/
/*  0% {*/
/*    background-position: 50% 50%;*/
/*  }*/
/*  25% {*/
/*    background-position: 100% 25%;*/
/*  }*/
/*  50% {*/
/*    background-position: 85% 100%;*/
/*  }*/
/*  75% {*/
/*    background-position: 25% 100%;*/
/*  }*/
/*  100% {*/
/*    background-position: 50% 50%;*/
/*  }*/
/*}*/

</style>
